import * as React from "react";
import { agent } from "../agent";
import LoginPage from "../pages/Login";
import { Redirect, useHistory } from "react-router-dom";
import { URL_PATHS } from "../routes";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { myDataActions } from "../store/myData";
import { AppState } from "../store";
import { smartAlert } from "../lib/confirm-alert";

const LoginContainer = () => {
    const dispatch = useDispatch();
    const myUser = useSelector((state: AppState) => state.myData.user);

    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();
    async function onLoginEmail(email: string) {
        setIsLoading(true);
        try {
            await agent.postAuthLogin({ email, isSignUp: false });
            dispatch(myDataActions.myDataAuthEmailSet(email));
            setIsLoading(false);
            history.push(URL_PATHS.verifyCode());
        } catch (e) {
            setIsLoading(false);
            await smartAlert("ログイン処理でエラーが発生しました。");
        }
    }
    if (myUser) {
        return <Redirect to={URL_PATHS.root()} />;
    }
    return <LoginPage onLoginEmail={onLoginEmail} isLoading={isLoading} />;
};

export default LoginContainer;
